export default __webpack_public_path__ + "images/like.svg?af1b41be85ccaba06ec469e228986154";